var map = {
	"./Amounts.vue": [
		"8181",
		"chunk-ca85db84",
		"chunk-655a82cf",
		"chunk-4212fcab",
		"chunk-4dd97431",
		"chunk-3209056a"
	],
	"./CafeCategories.vue": [
		"1889",
		"chunk-ca85db84",
		"chunk-655a82cf",
		"chunk-4212fcab",
		"chunk-4dd97431",
		"chunk-1b8b511e"
	],
	"./CafeEdit.vue": [
		"30b0",
		"chunk-ca85db84",
		"chunk-655a82cf",
		"chunk-4212fcab",
		"chunk-4dd97431",
		"chunk-42ebe672"
	],
	"./CafeMenu.vue": [
		"8f60",
		"chunk-ca85db84",
		"chunk-655a82cf",
		"chunk-4212fcab",
		"chunk-4dd97431",
		"chunk-6ee9ef1b"
	],
	"./CafeProducts.vue": [
		"75cc",
		"chunk-ca85db84",
		"chunk-655a82cf",
		"chunk-4212fcab",
		"chunk-4dd97431",
		"chunk-afe3e990"
	],
	"./CafeTags.vue": [
		"71e0",
		"chunk-ca85db84",
		"chunk-655a82cf",
		"chunk-4212fcab",
		"chunk-4dd97431",
		"chunk-63aeda9e"
	],
	"./Cafes.vue": [
		"e056",
		"chunk-ca85db84",
		"chunk-655a82cf",
		"chunk-4212fcab",
		"chunk-4dd97431",
		"chunk-0dd29a04"
	],
	"./ClientPage.vue": [
		"b654",
		"chunk-ca85db84",
		"chunk-655a82cf",
		"chunk-4212fcab",
		"chunk-3a12b799",
		"chunk-fccc48c4"
	],
	"./Control.vue": [
		"0616",
		"chunk-ca85db84",
		"chunk-655a82cf",
		"chunk-4dd97431",
		"chunk-3a12b799",
		"chunk-6f2deea0"
	],
	"./ControlCafes.vue": [
		"061b",
		"chunk-ca85db84",
		"chunk-655a82cf",
		"chunk-4dd97431",
		"chunk-3a12b799",
		"chunk-4c3d9b30"
	],
	"./CourierPage.vue": [
		"2bf8",
		"chunk-ca85db84",
		"chunk-655a82cf",
		"chunk-4212fcab",
		"chunk-4dd97431",
		"chunk-11fc2199"
	],
	"./FoodClient.vue": [
		"69dd",
		"chunk-ca85db84",
		"chunk-655a82cf",
		"chunk-4212fcab",
		"chunk-4dd97431",
		"chunk-046a3a7a"
	],
	"./Home.vue": [
		"bb51",
		"chunk-24e25446"
	],
	"./Kitchen.vue": [
		"872c",
		"chunk-ca85db84",
		"chunk-655a82cf",
		"chunk-4212fcab",
		"chunk-4dd97431",
		"chunk-dd0355ac"
	],
	"./Logs.vue": [
		"bbae",
		"chunk-ca85db84",
		"chunk-655a82cf",
		"chunk-4212fcab",
		"chunk-4dd97431",
		"chunk-831fd48c"
	],
	"./NetworkIssue.vue": [
		"9471",
		"chunk-2d0e542b"
	],
	"./NotFound.vue": [
		"9703",
		"chunk-2d0e5e97"
	],
	"./Oferta.vue": [
		"62e1",
		"chunk-07612d04"
	],
	"./Product.vue": [
		"d2f1",
		"chunk-ca85db84",
		"chunk-655a82cf",
		"chunk-4212fcab",
		"chunk-4dd97431",
		"chunk-78b42eb8"
	],
	"./Qr.vue": [
		"3769",
		"chunk-ca85db84",
		"chunk-655a82cf",
		"chunk-4212fcab",
		"chunk-4dd97431",
		"chunk-072e7fef"
	],
	"./ReferenceOperator.vue": [
		"65d0",
		"chunk-ca85db84",
		"chunk-655a82cf",
		"chunk-4212fcab",
		"chunk-4dd97431",
		"chunk-5e3ef555"
	],
	"./ReferencePayment.vue": [
		"3c50",
		"chunk-3a12b799",
		"chunk-78e55978"
	],
	"./ReferencePaymentComplete.vue": [
		"81e3",
		"chunk-ca85db84",
		"chunk-3a12b799",
		"chunk-10c26caa"
	],
	"./ReportPage.vue": [
		"7dca",
		"chunk-ca85db84",
		"chunk-655a82cf",
		"chunk-4212fcab",
		"chunk-4dd97431",
		"chunk-59332498"
	],
	"./Station.vue": [
		"14c5",
		"chunk-ca85db84",
		"chunk-655a82cf",
		"chunk-4212fcab",
		"chunk-4dd97431",
		"chunk-2d4c23ad"
	],
	"./Tags.vue": [
		"1884",
		"chunk-ca85db84",
		"chunk-655a82cf",
		"chunk-4212fcab",
		"chunk-4dd97431",
		"chunk-aa131b32"
	],
	"./Takeout.vue": [
		"3e8c",
		"chunk-ca85db84",
		"chunk-655a82cf",
		"chunk-4212fcab",
		"chunk-4dd97431",
		"chunk-f2a330a4"
	],
	"./UserLogin.vue": [
		"43f8",
		"chunk-ca85db84",
		"chunk-4212fcab",
		"chunk-3a12b799",
		"chunk-3f518bf5"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "1a5d";
module.exports = webpackAsyncContext;